<template>
  <div
    v-show="!hide"
    class="input-block-container"
  >
    <h3
      v-if="!noDisplayTitle"
      class="input-block-title"
    >
      {{ `${label} ${duplicateIndex >= 0 && duplicate !== null ? '#' + (duplicateIndex + 1) : ''}` }}
    </h3>
    <AddRemoveButtons
      v-if="
        (lastIndex === duplicateIndex && duplicate && duplicate > duplicateIndex) ||
          (lastIndex > 0 && duplicate !== null) ||
          (duplicate && lastIndex === -1)
      "
      :showAdd="
        (lastIndex === duplicateIndex && duplicate && duplicate > duplicateIndex) || (duplicate && lastIndex === -1)
      "
      :showDelete="duplicate !== null"
      :lastIndex="lastIndex"
      @add="$emit('add', { name, duplicateIndex })"
      @delete="$emit('delete', { name, duplicateIndex })"
      @set-default="$emit('setDefault', { name, duplicateIndex })"
      @clear="$emit('clear', { name, duplicateIndex })"
    />
  </div>
</template>
<script>
import AddRemoveButtons from '@/components/GenericComponents/AddRemoveButtons.vue'
export default {
  name: 'InputBlock',
  components: {
    AddRemoveButtons
  },
  props: {
    duplicate: {
      type: Number,
      default: null
    },
    hide: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ''
    },
    noDisplayTitle: {
      type: Boolean,
      default: false
    },
    name: {
      type: String,
      default: ''
    },
    duplicateIndex: {
      type: Number,
      default: 0
    },
    lastIndex: {
      type: Number,
      default: 0
    },
    children: {
      type: Array,
      default: null
    }
  },
  emits: ['clear', 'add', 'delete', 'setDefault']
}
</script>
<style lang="scss" scoped>
  .input-block-container {
    display: flex;
    flex-direction: row !important;
    justify-content: space-between;
    margin: 10px 0 10px 10px;

    /* Tablet (portrait) */
    @media only screen and (width >= 768px) {
      margin: 20px 0;
    }

    /* Desktops and laptops */
    @media only screen and (width >= 1024px) {
      margin: 20px 0;
    }

    /* Large screens */
    @media only screen and (width >= 1824px) {
      margin: 20px 0;
    }

    .input-block-title {
      margin: 10px 10px 10px 0;
      line-height: 1.8rem;
      text-align: left;
    }
  }
</style>
